import React from "react"
import { Box } from "@rebass/grid/emotion"

import Row from "./row"

const GoldenRatio = ({ main, side }) => (
  <Row>
    <Box p={3} width={[1, 1, (1 + Math.sqrt(5)) / 2 - 1]}>
      {main}
    </Box>
    <Box p={3} width={[1, 1, 1 - ((1 + Math.sqrt(5)) / 2 - 1)]}>
      {side}
    </Box>
  </Row>
)

export default GoldenRatio
